/**
 * Цех бириктиришдаги хатоларни тузатиш — **вақтинчалик**.
 *
 * Импорт цехни маҳсулот **номидан** ажратиб оляпти: агар номда цех белгиси
 * бўлса (масалан «…из ГТЦ-1»), қатор ўша цехга ёзилиб қоляпти, гарчи варақда
 * у бошқа цех блокида турса ҳам.
 *
 * Бу ерга фақат **иккита манба ҳам бир хил цехни кўрсатган** ҳолатлар
 * киритилади: `Сводки MM-YYYY.xlsx` даги бўлим блоки ва `Справочники.xlsx`
 * → «Нарастайка SPR». Иккови келишмаган ҳолатлар бу ерга ёзилмайди —
 * улар технолог қарорини талаб қилади ва `reference/API-BUGS.md` да қайд
 * этилган.
 *
 * Бэкенд тузатилгач: шу файлдаги массивни бўшатиш кифоя.
 */

export interface WorkshopFix {
  /** Маҳсулот номи (тўлиқ мослик, бўшлиқлар нормаллаштирилади). */
  product: string;
  /** API қайси цехни қайтаряпти. */
  from: string;
  /** Қайси цех бўлиши керак. */
  to: string;
  /** Далил — нима учун шундай. */
  why: string;
}

/**
 * 2026-08-13: бўш. Бэкенд цехни маҳсулот номидан ажратишни тўхтатди —
 * «Рений металлический из ГТЦ-1» энди ўзи «3 - Цех» да, «Молибденовые
 * штабики» «1 - Цех» да. Аввалги вақтинчалик тузатиш олиб ташланди.
 *
 * Механизм қолдирилди: шу турдаги хато яна чиқса, битта қатор қўшиш кифоя.
 * Қоида ўзгармайди — бу ерга фақат варақдаги бўлим блоки ва «Нарастайка SPR»
 * бир хил цехни кўрсатган ҳолатлар киритилади.
 */
export const WORKSHOP_FIXES: readonly WorkshopFix[] = [];

const norm = (s: string): string => String(s ?? "").replace(/\s+/g, " ").trim().toLowerCase();

const BY_PRODUCT = new Map(WORKSHOP_FIXES.map((f) => [norm(f.product), f]));

/**
 * Керак бўлса тузатилган цехни қайтаради, акс ҳолда келганини.
 * `plant` ўзгармайди — тузатилаётган ҳолатларда иккала цех ҳам битта заводда.
 */
export function fixWorkshop(product: string, workshop: string): string {
  const f = BY_PRODUCT.get(norm(product));
  return f && norm(f.from) === norm(workshop) ? f.to : workshop;
}

/** Ушбу қатор тузатилганми — интерфейсда изоҳ кўрсатиш учун. */
export function workshopFixNote(product: string, workshop: string): string | null {
  const f = BY_PRODUCT.get(norm(product));
  return f && norm(f.to) === norm(workshop) ? f.why : null;
}
